import { render, staticRenderFns } from "./GraficoEconomiaBot.vue?vue&type=template&id=77d0f3d4&scoped=true"
import script from "./GraficoEconomiaBot.vue?vue&type=script&lang=js"
export * from "./GraficoEconomiaBot.vue?vue&type=script&lang=js"
import style0 from "./GraficoEconomiaBot.vue?vue&type=style&index=0&id=77d0f3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d0f3d4",
  null
  
)

export default component.exports